// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iGVkiB9O7bsz3ybZgToo{border-bottom-left-radius:20px;border-bottom-right-radius:20px}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/dropdown/geofence-detail/geofence-detail-events.module.scss"],"names":[],"mappings":"AAAA,sBACC,8BAAA,CACA,+BAAA","sourcesContent":[".list {\n\tborder-bottom-left-radius: 20px;\n\tborder-bottom-right-radius: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export var list = `iGVkiB9O7bsz3ybZgToo`;
export default ___CSS_LOADER_EXPORT___;
